import React from 'react';
import { motion } from 'framer-motion';
import { FlowerIcon, BoxIcon } from 'lucide-react';
type CTAButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  icon?: BoxIcon;
  size?: 'md' | 'lg';
  className?: string;
  ariaLabel?: string;
  id?: string;
};
export function CTAButton({
  children,
  onClick,
  icon: _icon,
  size = 'md',
  className = '',
  ariaLabel,
  id
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-5 text-lg sm:text-xl' : 'px-6 py-3 text-sm sm:text-base';
  return <motion.button id={id} type="button" onClick={onClick} aria-label={ariaLabel} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-rosa font-medium tracking-wide text-white shadow-lg shadow-rosa/30 transition-colors hover:bg-rosa-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-rosa/40 ${sizing} ${className}`} data-id="element-1" data-mp="2ozi3fsmtzxys">
      <FlowerIcon className="h-5 w-5 shrink-0 text-crema" strokeWidth={1.8} aria-hidden="true" data-id="element-2" data-mp="199y5u6of1l01" />
      <span data-id="element-3" data-mp="1darsyxu1avrv">{children}</span>
    </motion.button>;
}